/** Focused beats fully partitioning each activity, in authored order. */
export const FOOD_DELIVERY_ROBOT_BEAT_PLANS = {
  "fdr-prelude:fdr-prelude-1": [
    {
      "id": "watch",
      "title": "Meet the café",
      "kind": "story",
      "blockIds": [
        "fdr-story-video"
      ]
    },
    {
      "id": "predict",
      "title": "Predict one possibility",
      "kind": "predict",
      "blockIds": [
        "fdr-first-risk",
        "fdr-swan-prelude",
        "fdr-prelude-gate"
      ]
    }
  ],
  "fdr-wonder:fdr-wonder-1": [
    {
      "id": "problem",
      "title": "What is our job?",
      "kind": "story",
      "blockIds": [
        "fdr-problem"
      ]
    },
    {
      "id": "guess",
      "title": "Make a prediction",
      "kind": "predict",
      "blockIds": [
        "fdr-criterion",
        "fdr-load-prediction",
        "fdr-swan-wonder",
        "fdr-wonder-gate"
      ]
    }
  ],
  "fdr-explore:fdr-explore-1": [
    {
      "id": "kit",
      "title": "Look closely at the physical parts",
      "kind": "observe",
      "blockIds": [
        "fdr-kit-story",
        "fdr-real-parts"
      ]
    },
    {
      "id": "predict",
      "title": "Find and predict",
      "kind": "predict",
      "blockIds": [
        "fdr-found-parts",
        "fdr-part-job",
        "fdr-swan-explore",
        "fdr-explore-gate"
      ]
    }
  ],
  "fdr-understand:fdr-understand-1": [
    {
      "id": "question",
      "title": "What moves?",
      "kind": "observe",
      "blockIds": [
        "fdr-energy-question"
      ]
    },
    {
      "id": "movie",
      "title": "Watch the mechanism explanation",
      "kind": "story",
      "blockIds": [
        "fdr-power-video"
      ]
    },
    {
      "id": "model",
      "title": "Connect the ideas",
      "kind": "model",
      "blockIds": [
        "fdr-switch-idea",
        "fdr-power-chain",
        "fdr-swan-understand",
        "fdr-understand-gate"
      ]
    }
  ],
  "fdr-apply:fdr-apply-1": [
    {
      "id": "prepare",
      "title": "Safety first",
      "kind": "safety",
      "blockIds": [
        "fdr-assemble-safety"
      ]
    },
    {
      "id": "pwo",
      "title": "Use 3D to assemble",
      "kind": "inspect",
      "blockIds": [
        "fdr-assembly-pwo"
      ]
    },
    {
      "id": "check",
      "title": "Confirm the actual build",
      "kind": "safety",
      "blockIds": [
        "fdr-build-check"
      ]
    }
  ],
  "fdr-apply:fdr-apply-2": [
    {
      "id": "guess",
      "title": "Predict the motion",
      "kind": "predict",
      "blockIds": [
        "fdr-motion-predict"
      ]
    },
    {
      "id": "try",
      "title": "Test briefly and record",
      "kind": "record",
      "blockIds": [
        "fdr-motion-test",
        "fdr-master-teacher-diagnostic",
        "fdr-swan-apply",
        "fdr-apply-gate"
      ]
    }
  ],
  "fdr-test-improve:fdr-test-1": [
    {
      "id": "recall",
      "title": "What happened at first?",
      "kind": "review",
      "blockIds": [
        "fdr-motion-recall"
      ]
    },
    {
      "id": "trial1",
      "title": "Test the tiny parcel",
      "kind": "record",
      "blockIds": [
        "fdr-delivery-test1"
      ]
    }
  ],
  "fdr-test-improve:fdr-test-2": [
    {
      "id": "movie",
      "title": "Watch the cargo explanation",
      "kind": "story",
      "blockIds": [
        "fdr-cargo-video"
      ]
    },
    {
      "id": "plan",
      "title": "Choose one change and predict",
      "kind": "predict",
      "blockIds": [
        "fdr-change-plan",
        "fdr-change-predict"
      ]
    }
  ],
  "fdr-test-improve:fdr-test-3": [
    {
      "id": "trial2",
      "title": "Compare the outcomes",
      "kind": "record",
      "blockIds": [
        "fdr-delivery-test2",
        "fdr-swan-improve",
        "fdr-test-improve-gate"
      ]
    }
  ],
  "fdr-explain:fdr-explain-1": [
    {
      "id": "recall",
      "title": "Read your real results",
      "kind": "review",
      "blockIds": [
        "fdr-compare-trials"
      ]
    },
    {
      "id": "reason",
      "title": "Build an explanation",
      "kind": "model",
      "blockIds": [
        "fdr-mechanism-chain",
        "fdr-evidence-claim",
        "fdr-swan-explain",
        "fdr-explain-gate"
      ]
    }
  ],
  "fdr-reflect:fdr-reflect-1": [
    {
      "id": "lookback",
      "title": "Your first idea",
      "kind": "review",
      "blockIds": [
        "fdr-original-risk"
      ]
    },
    {
      "id": "learn",
      "title": "What changed?",
      "kind": "reflect",
      "blockIds": [
        "fdr-thinking-change",
        "fdr-key-learning",
        "fdr-swan-reflect",
        "fdr-reflect-gate"
      ]
    }
  ],
  "fdr-grow:fdr-grow-1": [
    {
      "id": "new",
      "title": "Your next mission",
      "kind": "story",
      "blockIds": [
        "fdr-new-delivery"
      ]
    },
    {
      "id": "plan",
      "title": "Choose a next investigation",
      "kind": "grow",
      "blockIds": [
        "fdr-new-plan",
        "fdr-share",
        "fdr-swan-grow",
        "fdr-grow-gate"
      ]
    }
  ]
};
